import type { SVGProps } from 'react'
const SvgSyFolderAltFill = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={20} height={9} x={2} y={2} fillOpacity={0.24} rx={2} />
		<path
			fillRule="evenodd"
			d="M19 10h-7.343c-.818 0-1.226 0-1.594-.152-.367-.152-.657-.442-1.235-1.02l-.792-.792c-.444-.444-.665-.665-.934-.806a2 2 0 0 0-.337-.14C6.475 7 6.162 7 5.535 7c-1.438 0-2.157 0-2.67.353a2 2 0 0 0-.512.513C2 8.378 2 9.097 2 10.536V18c0 1.886 0 2.828.586 3.414S4.114 22 6 22h12c1.886 0 2.828 0 3.414-.586S22 19.886 22 18V7c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C20.398 10 19.932 10 19 10M6 14a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyFolderAltFill
